import React from 'react';

import { FieldAttributes, useField } from 'formik';
import { FormControlLabel, Radio, Tooltip } from '@mui/material';

type RadioProps = {
  label: string;
  disabled?: boolean;
  tooltip?: string;
} & FieldAttributes<any>;

const ValidatedRadio: React.FC<RadioProps> = ({ label, disabled = false, tooltip = '', ...props }) => {
  const [field] = useField<unknown>(props);

  return (
    <Tooltip title={tooltip} arrow>
      <FormControlLabel
        {...field}
        control={
          <Radio
            disabled={disabled}
            color="primary"
            size="small"
            onClickCapture={props.onClickCapture}
            style={{ paddingRight: '3px' }}
            id={props.id ? `${props.id}-radio-button` : `${props.name}-radio-button`}
          />
        }
        label={label}
        id={props.id ?? `${props.name}-radio`}
      />
    </Tooltip>
  );
};

export default ValidatedRadio;
